import { useCallback } from "react";
import { GroupsApi, useAPIAction } from "melco-shared-logic";
import { MachineGroupDetailFormValueType } from "../../components/reporting/machineGroups/MachineGroupDetailForm";

// export interface StatisticsGroupsAddInterface {
//   id: string;
//   melcoMachineStatisticsModelsCreateGroup: {
//     name: string;
//     machine_list: [];
//   };
// }

export const useStatisticsGroupsAdd = () => {
  const [StatisticsGroupsAdd] = useAPIAction(
    GroupsApi,
    async (
      api: GroupsApi,
      StatisticsGroupsAddDetails: MachineGroupDetailFormValueType
    ) => {
      const { id, name, machine_list } = StatisticsGroupsAddDetails;

      let data = await api.statisticsGroupsCreate({
        reportingMelcoMachineStatisticsModelsCreateGroup: {
          name: name,
          machine_list: machine_list,
        },
      });

      return {
        data,
        successMessages: [{ message: "default" }],
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "reporting.machinegroups.actions.add",
    }
  );

  return useCallback(
    async (StatisticsGroupsAddDetails: MachineGroupDetailFormValueType) => {
      return await StatisticsGroupsAdd(StatisticsGroupsAddDetails);
    },
    [StatisticsGroupsAdd]
  );
};
